<template lang="pug">
    .info-section
        .navigation
            navigation-button(:arrow="'left'", v-if="false") Выбор автомобиля
            .test-drive-info
                .text(:style="{display: 'none'}") В 3D-шоуруме представлен автомобиль Volkswagen Jetta в комплектации Status
                .action
                    template(v-if="isMobile")
                      .buttons-wrapper
                        button(ga-category="link",
                          ga-label="testDrive") Тест-драйв
                        button(ga-category="link",
                          ga-label="configurator") Конфигуратор
                      .buttons-wrapper
                        button(ga-category="link",
                          ga-label="requestOffer") Запрос предложения
                        button(ga-category="link",
                          ga-label="carsInStock") Автомобили в наличии
                    template(v-else)
                      .buttons-wrapper
                        button(ga-category="link",
                          ga-label="testDrive") Тест-драйв
                        button(ga-category="link",
                          ga-label="configurator") Конфигуратор
                        button(ga-category="link",
                          ga-label="requestOffer") Запрос предложения
                        button(ga-category="link",
                          ga-label="carsInStock") Автомобили в наличии
            navigation-button(:arrow="'right'", v-if="false") Перейти к Polo

        car-equipment(v-if="!isIframeMode && !fullScreen")
</template>
<script>
import NavigationButton from "./InfoSection/NavigationButton";
import CarEquipment from "./InfoSection/CarEquipment";
import isMobileMixin from "./mixins/isMobileMixin";
import {mapGetters} from "vuex";
import iframeMixin from "./mixins/iframeMixin";
export default {
  name: 'InfoSection',
  mixins: [isMobileMixin, iframeMixin],
  components: {CarEquipment, NavigationButton},
  data() {
    return {}
  },

  mounted() {
  },

  computed: {
    ...mapGetters(['isIframeMode', 'fullScreen', 'carModel'])
  },

  methods: {
  }
}
</script>